/* @flow */

import classNames from 'classnames';
import { compose } from 'ramda';
import * as React from 'react';
import { createUseStyles } from 'react-jss';

import styles from './HeroText.style';

type Props = {
  as?: string,
  layoutClass?: string,
  small?: boolean,
  children: React.Node,
};

const useStyles = createUseStyles(styles);

const HeroText = ({ as, layoutClass, small, children }: Props): React.Node => {
  const classes: Object = useStyles();

  const rootClasses = classNames(classes.root, layoutClass, {
    [classes['root-small']]: small,
  });

  const tagName = as || 'p';

  return React.createElement(tagName, { className: rootClasses }, children);
};

export default compose(React.memo)(HeroText);
